import { Outlet, Link } from 'react-router-dom';

/**
 * AuthLayout — Centered card layout for auth pages (login, register, etc.)
 *
 * Structure:
 * ┌───────────────────────────────────────────┐
 * │                                           │
 * │           ┌──────────────┐                │
 * │           │  Logo        │                │
 * │           │  Auth Form   │                │
 * │           │  (Outlet)    │                │
 * │           └──────────────┘                │
 * │                                           │
 * │           Footer links                    │
 * └───────────────────────────────────────────┘
 */
const AuthLayout = () => {
  return (
    <div className="relative flex items-center justify-center min-h-screen overflow-hidden">
      {/* ── Animated gradient background ── */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950 via-primary-900 to-primary-800">
        {/* Decorative shapes */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary-700/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 animate-pulse-soft" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-accent-700/15 rounded-full blur-3xl translate-x-1/3 translate-y-1/3 animate-pulse-soft" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-primary-600/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />

        {/* Subtle grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      {/* ── Main content ── */}
      <div className="relative z-10 w-full max-w-md mx-4 animate-fade-in-up">
        {/* Logo / Brand */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/logo.svg" alt="Zentrix" className="w-11 h-11 drop-shadow-lg" />
          <span className="text-2xl font-bold text-white tracking-tight font-display">
            Zentrix
          </span>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-modal p-7 sm:p-8">
          <Outlet />
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-primary-300/70">
            &copy; {new Date().getFullYear()} Zentrix. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
